<!-- Upload doc popover -->
<div class="upload-popover">
    <ion-content class="ion-padding">
      <form #uploadForm="ngForm">
        <div>
          <div class="grid-container">
            <div>
              <select name="documentType" id="documentType" class="input-field" name="documentType" [(ngModel)]="documentType" (change)="onDocumentTypeChange()" required>
                <option value="" hidden>-- select document type --</option>
                <option *ngFor="let docType of documentTypesArr" [value]="docType">{{docType}}</option>
              </select>
            </div>
            <div>
              <input class="input-field" type="text" placeholder="Enter Document Type" name="otherDocumentType" [(ngModel)]="otherDocumentType" *ngIf="documentType == 'Others'" required>
            </div>
            <div>
              <input class="input-field" type="file" accept=".png, .jpg, .jpeg, .pdf" (change)="onFileSelected($event)" required>
            </div>
            <!-- <div *ngIf="attachedFileName">
              <p class="attached-doc clickable-file ms-1" (click)="openAttachedFile()">{{ attachedFileName }}</p>
            </div> -->
          </div>
          <div class="buttons-container d-flex justify-content-end">
            <button #documentResetBtn type="reset"></button>
            <ion-button class="unfilled-gray-btn me-1"  type="reset" (click)="resetAttachemenForm()">Reset</ion-button>
            <ion-button class="filled-blue-btn" [disabled]="!uploadForm.valid" (click)="submitAttachmentForm()">Submit</ion-button>
          </div>
        </div>
      </form>
    </ion-content>
</div>